<template>
  <div class="view">
    <!-- <div class="">
      {{stage}}
    </div> -->
    <header>

      <!-- <div class="absolute top-0 left-0">
        <logo />
      </div> -->

      <h1>About</h1>

      <div class="close-view absolute right-4 top-4">
        <router-link :to="{ name: 'Home', params: {} }" class="w-8 h-8 block group">
          <div class="absolute top-1/2 right-0 transform rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
          <div class="absolute top-1/2 right-0 transform -rotate-45 h-0.5 w-8 bg-white group-hover:bg-red-600"></div>
        </router-link>
      </div>
    </header>

    <VueShowdown
    :markdown="md"
    flavor="github"
    tag="article"
    />
  </div>
</template>

<script>
// import logo from '@/components/Intro/logo'
import mdFile from '@/markdown/about.md'
// @ is an alias to /src
export default {
  name: 'About',
  data () {
    return {
      text: ''
    }
  },
  components: {
    // logo
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  @apply fixed inset-0 overflow-y-auto;
  -webkit-overflow-scrolling: touch;
  z-index:40;
  z-index: 9999 !important;
}
article {
  @apply pt-24 pb-48;
}
</style>
